export const analyticsOrderData = {
  "monthly_sales": [
    { "month": 1, "year": 2023, "order_count": 145, "total_sales": 12000 },
    { "month": 2, "year": 2023, "order_count": 120, "total_sales": 14500 },
    { "month": 3, "year": 2023, "order_count": 430, "total_sales": 16000 },
    { "month": 4, "year": 2023, "order_count": 200, "total_sales": 18000 },
    { "month": 5, "year": 2023, "order_count": 145, "total_sales": 20000 },
    { "month": 6, "year": 2023, "order_count": 120, "total_sales": 17500 },
    { "month": 7, "year": 2023, "order_count": 430, "total_sales": 19000 },
    { "month": 8, "year": 2023, "order_count": 200, "total_sales": 21000 },
    { "month": 9, "year": 2023, "order_count": 145, "total_sales": 22000 },
    { "month": 10, "year": 2023, "order_count": 120, "total_sales": 25000 },
    { "month": 11, "year": 2023, "order_count": 430, "total_sales": 27000 },
    { "month": 12, "year": 2023, "order_count": 200, "total_sales": 30000 },
    { "month": 1, "year": 2024, "order_count": 145, "total_sales": 31000 },
    { "month": 2, "year": 2024, "order_count": 120, "total_sales": 32000 },
    { "month": 3, "year": 2024, "order_count": 430, "total_sales": 34000 },
    { "month": 4, "year": 2024, "order_count": 200, "total_sales": 36000 },
    { "month": 5, "year": 2024, "order_count": 145, "total_sales": 37000 },
    { "month": 6, "year": 2024, "order_count": 120, "total_sales": 39000 },
    { "month": 7, "year": 2024, "order_count": 430, "total_sales": 41000 },
    { "month": 8, "year": 2024, "order_count": 200, "total_sales": 43000 },
    { "month": 9, "year": 2024, "order_count": 145, "total_sales": 45000 },
    { "month": 10, "year": 2024, "order_count": 120, "total_sales": 47000 },
    { "month": 11, "year": 2024, "order_count": 430, "total_sales": 49000 },
    { "month": 12, "year": 2024, "order_count": 200, "total_sales": 51000 },
    { "month": 1, "year": 2025, "order_count": 145, "total_sales": 53000 },
    { "month": 2, "year": 2025, "order_count": 120, "total_sales": 55000 },
    { "month": 3, "year": 2025, "order_count": 430, "total_sales": 57000 },
    { "month": 4, "year": 2025, "order_count": 200, "total_sales": 59000 },
    { "month": 5, "year": 2025, "order_count": 145, "total_sales": 61000 },
    { "month": 6, "year": 2025, "order_count": 120, "total_sales": 63000 },
    { "month": 7, "year": 2025, "order_count": 430, "total_sales": 65000 },
    { "month": 8, "year": 2025, "order_count": 200, "total_sales": 67000 },
    { "month": 9, "year": 2025, "order_count": 145, "total_sales": 69000 },
    { "month": 10, "year": 2025, "order_count": 120, "total_sales": 71000 },
    { "month": 11, "year": 2025, "order_count": 430, "total_sales": 73000 },
    { "month": 12, "year": 2025, "order_count": 200, "total_sales": 75000 }
  ],

  "orders_by_status": [
    {
      "total_count": 45,
      "total_sales": 125000,
      "status": "pending"
    },
    {
      "total_count": 32,
      "total_sales": 98000,
      "status": "delivered"
    },
    {
      "total_count": 25,
      "total_sales": 75000,
      "status": "cancelled"
    },
    {
      "total_count": 15,
      "total_sales": 50000,
      "status": "confirmed"
    }
  ]
}


export const analyticsCardData = (resource: string) => {
  if (resource === "analytics/accounts") {
    return [
      {
        "count": 17486,
        "status": "approved"
      },
      {
        "count": 137,
        "status": "banned"
      },
      {
        "count": 8,
        "status": "pending"
      }
    ]
  }

  if (resource === "analytics/products") {
    return [
      {
        "count": 438,
        "status": "active"
      },
      {
        "count": 3575,
        "status": "out_of_stock"
      }
    ]
  }

  else {
    return []
  }
}

export const cityStatesData = {
  "Andaman and Nicobar Islands": ["Port Blair"],
  "Andhra Pradesh": ["Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Tirupati"],
  "Arunachal Pradesh": ["Itanagar", "Tawang", "Pasighat", "Ziro", "Bomdila"],
  "Assam": ["Guwahati", "Tezpur", "Dibrugarh", "Silchar", "Jorhat"],
  "Bihar": ["Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Darbhanga"],
  "Chandigarh": ["Chandigarh"],
  "Chhattisgarh": ["Raipur", "Bhilai", "Bilaspur", "Korba", "Durg"],
  "Dadra and Nagar Haveli and Daman and Diu": ["Silvassa", "Daman", "Diu"],
  "Delhi": ["New Delhi", "Delhi"],
  "Goa": ["Panaji", "Vasco da Gama", "Margao", "Mapusa", "Ponda"],
  "Gujarat": ["Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar"],
  "Haryana": ["Faridabad", "Gurgaon", "Panipat", "Ambala", "Hisar"],
  "Himachal Pradesh": ["Shimla", "Dharamshala", "Mandi", "Solan", "Kullu"],
  "Jammu and Kashmir": ["Srinagar", "Jammu", "Anantnag", "Baramulla", "Udhampur"],
  "Jharkhand": ["Ranchi", "Jamshedpur", "Dhanbad", "Bokaro Steel City", "Deoghar"],
  "Karnataka": ["Bengaluru", "Mysuru", "Hubballi-Dharwad", "Mangaluru", "Belagavi"],
  "Kerala": ["Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Malappuram"],
  "Ladakh": ["Leh", "Kargil"],
  "Lakshadweep": ["Kavaratti"],
  "Madhya Pradesh": ["Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain"],
  "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Nashik", "Aurangabad"],
  "Manipur": ["Imphal", "Thoubal", "Bishnupur", "Churachandpur", "Ukhrul"],
  "Meghalaya": ["Shillong", "Tura", "Nongstoin", "Jowai", "Baghmara"],
  "Mizoram": ["Aizawl", "Lunglei", "Saiha", "Champhai", "Kolasib"],
  "Nagaland": ["Kohima", "Dimapur", "Mokokchung", "Tuensang", "Wokha"],
  "Odisha": ["Bhubaneswar", "Cuttack", "Rourkela", "Berhampur", "Sambalpur"],
  "Puducherry": ["Puducherry", "Karaikal", "Mahe", "Yanam"],
  "Punjab": ["Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda"],
  "Rajasthan": ["Jaipur", "Jodhpur", "Kota", "Udaipur", "Bikaner"],
  "Sikkim": ["Gangtok", "Namchi", "Gyalshing", "Mangan", "Singtam"],
  "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem"],
  "Telangana": ["Hyderabad", "Warangal", "Nizamabad", "Karimnagar", "Khammam"],
  "Tripura": ["Agartala", "Udaipur", "Dharmanagar", "Kailasahar", "Belonia"],
  "Uttar Pradesh": ["Lucknow", "Kanpur", "Ghaziabad", "Agra", "Varanasi"],
  "Uttarakhand": ["Dehradun", "Haridwar", "Roorkee", "Haldwani", "Rudrapur"],
  "West Bengal": ["Kolkata", "Howrah", "Durgapur", "Asansol", "Siliguri"]
}

export const uomsData = ["pcs", "kg", "gm", "litre", "ml", "dozen", "pack", "box", "bag", "set", "other", "meter"]

export const videos = [
  {
      title: "Product send in broadcast",
      description: "This is the demo of sending the products in broadcasts on Admin Dashboard.",
      youtubeUrl: "https://youtu.be/x0DEharHSTc",
  },
  {
      title: "Kayaan chat admin dashboard, send outstanding to accounts feature demo",
      description: "Demo for how to send the outstanding to contacts from Admin Dashboard.",
      youtubeUrl: "https://youtu.be/UjQbl6KpfFc",
  },
  {
      title: "Kayaan chat app, dispatch report and send outstanding demo",
      description: "",
      youtubeUrl: "https://youtu.be/p5WGrFUXitA",
  },
  {
      title: "Kayaan chat Admin Dashboard, approve user and add company demo",
      description: "Approving user and attaching set company to it on Admin Dashboard.",
      youtubeUrl: "https://youtu.be/RsMhiKKdLZU",
  },
  {
    title: "Kayaan chat app, Share documents from chat",
    description: "Sharing documents from chat on Kayaan chat app.",
    youtubeUrl: "https://youtube.com/shorts/MuS-Kja2TFE?feature=share",
  },
  {
    title: "Kayaan chat app, Power tabs",
    description: "Power tabs in Kayaan chat app.",
    youtubeUrl: "https://youtube.com/shorts/oTMY4TMyD9k?feature=share",
  }, 
  {
    title: "Kayaan Prints Catalogue PDF Upload Button Demo",
    description: "Uploading PDF catalog on Kayaan chat admin dashboard.",
    youtubeUrl: "https://youtu.be/YtpSqM9KYdk",
  }
];